;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('zlEditTags', TagsDirective)

  TagsDirective.$inject = ['$uibModal']

  function TagsDirective ($uibModal) {
    return {
      restrict: 'E',
      bindToController: true,
      controller: [ 'TagManager', 'ColorService', function (TagManager, ColorService) {
        var self = this

        self.$onInit = () => {
          _.extend(self, {
            loadTags: loadTags,
            addTag: addTag,
            getColor: getColor,
            removeTag: removeTag
          })
        }
        /**
         * Load existing tags from data + if needed, adds the input as a new tag for adding it on the fly
         */
        function loadTags (query) {
          self.loadingTags = true
          return TagManager.get(TagManager.query().search(query, 'label')).then(function (data) {
            self.tags = data.data
            // If the tag doesn't exist, add it to the list. addTag will take care of saving if it is added.
            // we add a random color code.
            if (!_.includes(_.map(self.tags, 'label'), query.toUpperCase()) && query.length) {
              self.tags.push(TagManager.create({
                label: query.toUpperCase(),
                color: '#' + _.padStart(Math.floor(Math.random() * 16777215).toString(16), 6, 0)
              }))
            }
            self.tags = _.reject(self.tags, function (tag) {
              return _.includes(_.map(self.ngModel, 'label'), tag.label)
            })
            self.loadingTags = false
            return self.tags
          })
        }

        function addTag (tag) {
          if (!tag) return
          if (!tag._id) {
            tag.save().then(function () {
              self.ngModel.push(tag)
              self.selectedTag = ''
            })
          } else {
            self.ngModel.push(tag)
            self.selectedTag = ''
          }
        }

        function removeTag (index) {
          self.ngModel.splice(index, 1)
          if (self.form) self.form.$dirty = true
        }

        function getColor (v) {
          return ColorService.getLuminance(v) > 200 ? '#333' : '#eee'
        }
      } ],
      templateUrl: '/app/common/directives/tags/edit-tags.html',
      controllerAs: 'TagsEditCtrl',
      scope: {
        'ngModel': '=',
        editable: '=',
        form: '='
      }
    }
  }
})(window.angular, window._)
